import {make_createActionType} from 'helpers'
const createActionType = make_createActionType('TRACKING')

export const PUSH_EVENT = createActionType('PUSH')



// WEBPACK FOOTER //
// ./src/hocs/TrackingHOC/constants.js